<script>
  import Page from '$routes/(app)/kategoriya-[catalog]/+page.svelte';
  export let data;
</script>

<Page {data} />
